import moment from "moment";

export const getTimeFormat = (date: Date | undefined): string => {
    if (date == undefined || (moment(date).format("LT") === '00:00')) return '';  
    return moment(date).format("LT");
}

export const getDateTimeFormat = (date: Date | undefined): string => {
    if (date == undefined || (moment(date).format("LT") === '00:00')) return '';  
    return moment(date).format("DD/MM/YY LT");
}
